import { Badge } from "@/components/ui/badge";

export const FILING_STATUS = {
  requested: { label: "Requested", cls: "bg-sky-50 text-sky-700 border-sky-200", bar: "bg-sky-500", hint: "Customer asked us to prepare this filing." },
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-700 border-slate-200", bar: "bg-slate-400", hint: "Being prepared by Safer Highways." },
  awaiting_approval: { label: "Awaiting your approval", cls: "bg-amber-50 text-amber-800 border-amber-300", bar: "bg-amber-500", hint: "Customer must review and authorize before filing." },
  changes_requested: { label: "Changes requested", cls: "bg-rose-50 text-rose-700 border-rose-200", bar: "bg-rose-500", hint: "Customer asked for edits." },
  approved: { label: "Approved · ready to file", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", bar: "bg-emerald-500", hint: "Authorized. Safer Highways will file." },
  filed: { label: "Filed", cls: "bg-blue-50 text-blue-700 border-blue-200", bar: "bg-blue-600", hint: "Submitted to the agency." },
  completed: { label: "Completed", cls: "bg-slate-900 text-white border-slate-900", bar: "bg-slate-900", hint: "Done." },
  rejected: { label: "Cancelled", cls: "bg-slate-100 text-slate-500 border-slate-200 line-through", bar: "bg-slate-300", hint: "Cancelled." },
};

export function FilingStatusBadge({ status, isAdmin }) {
  const s = FILING_STATUS[status] || FILING_STATUS.draft;
  const label = status === "awaiting_approval" && isAdmin ? "Awaiting customer" : s.label;
  return <Badge className={`border ${s.cls}`} data-testid={`filing-status-${status}`}>{label}</Badge>;
}

export const money = (v) => (v == null ? "—" : `$${Number(v).toFixed(2)}`);

export function daysBadge(dateStr) {
  if (!dateStr) return <span className="text-slate-400">—</span>;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const days = Math.round((new Date(dateStr) - today) / 86400000);
  if (days < 0) return <Badge className="bg-rose-50 text-rose-700 border border-rose-200">Expired · {dateStr}</Badge>;
  if (days <= 30) return <Badge className="bg-amber-50 text-amber-800 border border-amber-300">{days}d · {dateStr}</Badge>;
  return <span className="font-mono text-xs text-slate-600">{dateStr}</span>;
}

export function deadlineTone(days) {
  if (days < 0) return "border-rose-300 bg-rose-50 text-rose-800";
  if (days <= 14) return "border-rose-200 bg-rose-50 text-rose-700";
  if (days <= 45) return "border-amber-300 bg-amber-50 text-amber-800";
  return "border-emerald-200 bg-emerald-50 text-emerald-700";
}

export const periodHint = { "2290": "Tax year, e.g. 2026-2027 (Jul 1 – Jun 30)", ifta: "Quarter, e.g. 2026-Q2", irp: "Registration year, e.g. 2027" };
export const ADMIN_DOC_TYPES = ["Completed filing (as submitted)", "2290 Schedule 1", "IFTA Return", "IFTA License", "IRP Cab Card", "Prep worksheet", "Receipt", "Other"];
export const CUSTOMER_DOC_TYPES = ["Signed authorization / Form 8453-EX", "Prior year return", "Mileage / fuel records", "Registration / cab card", "Payment receipt", "Other supporting form"];
